<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      :id="`tooltip-target-${item.title}`"
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-tooltip
      :target="`tooltip-target-${item.title}`"
      triggers="hover"
      :title="item.title"
      placement="right"
      :disabled="disabledToolTip(item.title)"
      variant="light"
    />
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()
    const disabledToolTip = item => {
      switch (item) {
        case 'IMPRIMIR ETIQUETAS': return false
        case 'IMP. ETQ. POR CHAVE': return false
        case 'LAYOUTS IMP. ENVIO': return false
        case 'LAYOUTS IMP. REVERSA': return false
        case 'ENDEREÇO REVERSA': return false
        default: return true
      }
    }
    return {
      isActive,
      linkProps,
      updateIsActive,
      disabledToolTip,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
